import React from "react";
import Helmet from "react-helmet";

export default React.memo(
  ({
    author,
    siteUrl,
    datePublished,
    dateModified,
    description,
    image,
    isBlogPost,
    organization,
    title,
    url
  }) => {
    const baseSchema = [
      {
        "@context": "http://schema.org",
        "@type": "Organization",
        "@id": "https://blog.hckrt.com#organization",
        name: "Hackrate Blog",
        url: "https://blog.hckrt.com",
        sameAs: ["https://twitter.com/hackrate"],
        legalName: "Hackrate Ltd.",
        logo: {
          "@type": "ImageObject",
          url: "https://blog.hckrt.com/img/android-chrome-144x144.png",
          width: 144,
          height: 144
        }
      },
      {
        "@context": "http://schema.org",
        "@type": "WebSite",
        "@id": "https://blog.hckrt.com#website",
        url: "https://blog.hckrt.com",
        name: "Hackrate Blog",
        alternateName: "Blog of Hackrate Ethical Hacking Platform",
        author: {
          "@id": "https://blog.hckrt.com#organization"
        }
      },
      {
        "@context": "http://schema.org",
        "@type": "WebPage",
        "@id": url,
        url,
        headline: title,
        description,
        publisher: {
          "@id": "https://blog.hckrt.com#organization"
        },
        sourceOrganization: {
          "@id": "https://blog.hckrt.com#organization"
        }
      }
    ];

    const schema = isBlogPost
      ? [
          ...baseSchema,
          {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                item: {
                  "@id": url,
                  name: title,
                  image
                }
              }
            ]
          },
          {
            "@context": "http://schema.org",
            "@type": "BlogPosting",
            url,
            name: title,
            headline: title,
            image: {
              "@type": "ImageObject",
              url: image
            },
            description,
            author: {
              "@id": "https://blog.hckrt.com#organization"
            },
            publisher: {
              "@id": "https://blog.hckrt.com#organization"
            },
            mainEntityOfPage: {
              "@type": "WebSite",
              "@id": siteUrl
            },
            datePublished,
            dateModified: dateModified ? dateModified : datePublished
          }
        ]
      : baseSchema;

    return (
      <Helmet>
        {/* Schema.org tags */}
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
        <script src="//embed.typeform.com/next/embed.js"></script>
      </Helmet>
    );
  }
);
